export default __webpack_public_path__ + "static/media/SCIENCE_CHEMISTRY_PHYSICS.4604e5c3.svg";